module.exports = __webpack_public_path__ + "static/img/10.daebefd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/eng/10.png
// module id = RxCn
// module chunks = 0